import React, {useEffect, useRef, useState} from "react";
import {Badge, Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/esm/Form";
import {useController, useFieldArray} from "react-hook-form";
import axios from "../../../../helpers/axios";
import SearchSelect from "../../../../components/searchSelect";

const emptyTiedUp = (issuedBy) => ({
  tiedUpIssuedBy: issuedBy || "",
  tiedUpComment: "",
  tiedUpPaid: false,
  tiedUpChecked: false
});

const resizeComment = (el) => {
  if (!el) return
  el.style.height = "calc(1.5em + 0.75rem + 2px)"
  if (el.scrollHeight > el.clientHeight) {
    el.style.height = `${el.scrollHeight}px`
  }
}

const TiedUpFields = ({fieldPrefix, item, employees, formController, onRemove, onAdd, index}) => {
  const {register, control} = formController;
  const {field: {onChange, value}} = useController({
    name: `${fieldPrefix}.tiedUpIssuedBy`,
    control,
    defaultValue: item.tiedUpIssuedBy || ""
  });
  const {ref: commentRef, ...commentField} = register(`${fieldPrefix}.tiedUpComment`);

  return (
    <Row className={"segmentContainer mt-2 align-items-start"}>
      <Col xs={12}>
        {item.id && (
          <input type={"hidden"}
                 defaultValue={item.id}
                 {...register(`${fieldPrefix}.id`)}/>
        )}
        <div className={"d-flex justify-content-between align-items-center mb-2"}>
          <div className={"d-flex align-items-center"}>
            <span>Ответственный за привязку №{index + 1}</span>
            <button type={"button"}
                    className={"btn btn-link btn-sm text-danger p-0 ml-2"}
                    onClick={onRemove}>
              Удалить
            </button>
          </div>
          {onAdd && (
            <Badge
              variant="success"
              onClick={onAdd}
            >
              <i className={"la la-plus"}/> Добавить ответственного
            </Badge>
          )}
        </div>
      </Col>
      <Col xs={4}>
        {employees && <SearchSelect
          onChange={onChange}
          defaultValue={value}
          label={"Имя"}
          array={employees}/>}
      </Col>
      <Col xs={8}>
        <Form.Control
          as="textarea"
          rows={1}
          defaultValue={item.tiedUpComment}
          placeholder={"Коментарий для привязки"}
          style={{overflow: "hidden", resize: "none"}}
          {...commentField}
          ref={(el) => {
            commentRef(el)
            resizeComment(el)
          }}
          onInput={(e) => resizeComment(e.target)}
        />
      </Col>
    </Row>
  );
};

const TicketTiedUps = ({prefix, formController}) => {
  const {control, getValues, setValue} = formController;
  const [employees, setEmployees] = useState();
  const createdRef = useRef(false);
  const tiedUpsControl = useFieldArray({
    control,
    name: `${prefix}.tiedUps`,
    keyName: "customId"
  });

  useEffect(() => {
    axios.post("/api/users/emplSearch", {operatorOneS: true})
      .then(({data}) => {
        setEmployees(data.data.map(user => ({
          label: user.label,
          value: user.value._id
        })))
      })
      .catch(() => setEmployees([]))
  }, []);

  useEffect(() => {
    if (createdRef.current || tiedUpsControl.fields.length) return
    createdRef.current = true
    tiedUpsControl.append(emptyTiedUp(getValues("issuedBy")))
  }, []);

  const removeTiedUp = (index) => {
    if (tiedUpsControl.fields.length <= 1) {
      setValue(`${prefix}.tiedUp`, false)
      setValue(`${prefix}.tiedUps`, [])
      return
    }
    tiedUpsControl.remove(index)
  }

  return (
    <div className={"mt-2 border-bottom mb-2"}>
      {tiedUpsControl.fields.map((item, index) => (
        <TiedUpFields
          key={item.customId}
          index={index}
          fieldPrefix={`${prefix}.tiedUps[${index}]`}
          item={item}
          employees={employees}
          formController={formController}
          onRemove={() => removeTiedUp(index)}
          onAdd={index === 0 ? () => tiedUpsControl.append(emptyTiedUp()) : undefined}
        />
      ))}
    </div>
  );
};

export default TicketTiedUps;
